import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isPWA(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    // @ts-expect-error navigator.standalone is not supported in all browsers
    window.navigator.standalone === true
  );
}

export function onInstagramBrowser(): boolean {
  return window.navigator.userAgent.includes("Instagram");
}

export function isIPhone(): boolean {
  return window.navigator.userAgent.includes("iPhone");
}

export function isAndroid(): boolean {
  return window.navigator.userAgent.includes("Android");
}

export function mobileBrowser(): string {
  return isIPhone() ? "Safari" : "Chrome";
}

export function formatCurrency(
  amount: number,
  currency: string,
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = 0,
): string {
  return new Intl.NumberFormat("es-UY", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
  }).format(amount);
}

export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat("es-UY", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function formatPercentage(percentage: number): string {
  return new Intl.NumberFormat("es-UY", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(percentage / 100);
}

export function formatRelativeTime(date: Date): string {
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return "Hace un momento";
  if (diffInSeconds < 3600)
    return `Hace ${Math.floor(diffInSeconds / 60)} minutos`;
  if (diffInSeconds < 86400)
    return `Hace ${Math.floor(diffInSeconds / 3600)} horas`;
  if (diffInSeconds < 2592000)
    return `Hace ${Math.floor(diffInSeconds / 86400)} días`;

  return formatDate(date);
}
